export enum NEWRELIC_TABLES {
    TIMER_RESPONSE_RECIEVED = "timer_response_recieved",
    TIMER_RENDERED = "timer_rendered",
    TIMER_END_UPDATE_CART_CALLED = "timer_end_update_cart_called",
    CRAZY_DEALS_TIMER_END_UPDATE_CART_CALLED = "crazy_deals_timer_end_update_cart_called",
    CHECKOUT_WEB_CART_SESSION_RECORD = "checkout_web_cart_session_record",
    CHECKOUT_WEB_DINEOUT_CART_SESSION_RECORD = "checkout_web_dineout_cart_session_record",
    PAYMENT_WEB_EXTERNAL_API = "payment_web_external_api",
    PAYMENT_WEB_EXTERNAL_API_ERROR = "payment_web_external_api_error",
    PAYMENT_WEB_EXTERNAL_API_NETWORK_ERROR = "payment_web_external_place_order_api_network_error",
    PAYMENT_WEB_NATIVE_BRIDGE_REQUEST = "payment_web_native_bridge_request",
    PAYMENT_WEB_NATIVE_BRIDGE_RESPONSE = "payment_web_native_bridge_response",
    WEBVIEW_REFRESH_STATE = "webview_refresh_state",
    WEBVIEW_REFRESH_STATE_ERROR = "webview_refresh_state_error",
    WEBVIEW_REFRESH_STATE_RESTORE = "webview_refresh_state_restore",
    WEBVIEW_REFRESH_PSR = "webview_refresh_journey_psr",
    WEBVIEW_REFRESH_DEBUG = "webview_refresh_journey_debug",
    WEBVIEW_REFRESH_INFO = "webview_refresh_journey_info",
    WEBVIEW_REFRESH_JS_BRIDGE_OVERRIDE = "webview_refresh_js_bridge_override",
    CHECKOUT_WEB_VIEW = "checkout_web_view",
    DINEOUT_CHECKOUT_WEB_VIEW = "dineout_checkout_web_view",
    TABLE_RESERVATION_CART_P0_COMPONENT_IMPRESSION = "table_reservation_cart_crucial_components_impression",
    TABLE_RESERVATION_CART_LOCAL_CART_ERROR = "table_reservation_cart_local_cart_error",
    TABLE_RESERVATION_CART_ERROR_PAGE_IMPRESSION = "table_reservation_cart_error_page_impression",
    ADD_SWIGGY_MONEY_AUTOPAY_FAILURE = "add_swiggy_money_autopay_failure",
    PAYMENT_WEB_CONFIRM_ORDER = "payment_web_confirm_order",
    PAYMENT_WEB_ORDER_TERMINAL_ALERT_NAVIGATIONS = "payment_web_order_terminal_alert_navigations",
    PAYMENT_WEB_DIRECT_PLACE_ORDER = "payment_web_direct_place_order",
    NEW_PAYMENT_FAILURE_HALF_CARD_RENDERED = "NEW_PAYMENT_FAILURE_HALF_CARD_RENDERED",
    PAYMENT_WEB_VIEW = "payment_web_view",
    PAYMENT_MODES_ADD_NEW_CARD = "payment_modes_add_new_card",
    PAYMENT_MODES_MANAGE_CARD = "PAYMENT_MODES_MANAGE_CARD",
    PAYMENT_MODES_SECURE_CARD = "PAYMENT_MODES_SECURE_CARD",
    PAYMENT_MODES_MANAGE_IN_APP_UPI = "PAYMENT_MODES_MANAGE_IN_APP_UPI",
    PAYMENT_NATIVE_BRIDGE_AMAZON_SDK = "payment_native_bridge_amazon_sdk",
    INVALID_WALLET = "wp_invalid_wallet",
    WEB_CHECKOUT_BACK_BUTTON_PAYMENT_SCREEN = "web_checkout_back_button_payment_screen",
    ADD_SWIGGY_MONEY_PAGE_VIEW = "add_swiggy_money_page_view",
    PAYMENT_PROCESS_ORDER_STATE_ERROR = "payment_process_order_state_error",
    WEB_PAYMENTS_STORAGE_NOT_AVAILABLE = "web_payments_storage_not_available",
    JUSPAY_SDK_NOT_AVAILABLE = "wp_juspay_sdk_not_avalble",
    PAYMENTS_WEB_PLACE_ORDER = "payments_web_place_order",
    PAYMENTS_WEB_DIRECT_PLACE_ORDER = "payments_web_direct_place_order",
    PAYMENTS_WEB_DIRECT_PLACE_ORDER_FAILURE = "payments_web_direct_place_order_failure",
    WP_ADD_NEW_CARD_PROCEED_TO_PAY = "WP_ADD_NEW_CARD_PROCEED_TO_PAY",
    PAYMENT_WEB_CONFIRM_ORDER_FAILED = "payment_web_confirm_order_failed",
    AMAZONPAYSDK_FAILURES = "amazonpaysdk_failures",
    INVALID_CHECKOUT_META = "web_payments_invalid_checkout_meta",
    PAYMENT_AUTOPAY_CANCEL_TRANSACTION_FAILED = "payment_autopay_cancel_transaction_failed",
    PAYMENT_WEB_PLACE_ORDER_FAILED = "payment_web_place_order_failed",
    CARD_OFFER_TABLE = "card_offer_table",
    CARD_OFFER_AND_REWARDS_TABLE = "card_offer_and_rewards",
    INLINE_WEB_CART_API_STATE = "inline_web_cart_api_state",
    DINEOUT_INLINE_WEB_CART_API_STATE = "dineout_inline_web_cart_api_state",
    CW_INVALID_HEADERS = "cw_invalid_headers",
    TRANSITION_SCREEN_ERROR = "transition_screen_error",
    CW_DNS_TIME = "checkout_web_dns_time",
    CART_ERROR = "cart_error",
    CART_INLINE_EMPTY_ITEMS = "cart_inline_empty_items",
    CART_INLINE_INVALID_LOCALCART = "cart_inline_invalid_localcart",
    DINEOUT_CART_INLINE_INVALID_LOCALCART = "dineout_cart_inline_invalid_localcart",
    TURBO_LOADER_DEBUG = "turbo_loader_debug",
    TURBO_SCREEN_LOADER_STATE = "turbo_screen_loader_state",
    TURBO_SDK_LOADER_SCREEN_ERROR = "turbo_sdk_loader_screen_error",
    DO_PAYMENT_SUCCESS_PAGE_VIEW = "dineout_payment_success_page_view",
    TRANSITION_SCREEN_LOAD_TIME = "transition_screen_load_time",
    CART_LOTTIE_ERROR = "cart_lottie_error",
    GENERIC_ERROR_PAGE_IMPRESSION = "generic_error_page_impression",
    INITIAL_IMPRESSION_COUPON_WIDGET = "initial_impression_coupon_widget",
    ONSCROLL_IMPRESSION_COUPON_WIDGET = "onscroll_impression_coupon_widget",
    POST_LOGIN_FLOW = "post_login_flow",
    CHECKOUT_WEB_ERROR_BOUNDARY = "checkout_web_error_boundary",
    HERO_INLINE_EVENT_CAPTURE_ERROR = "hero_inline_event_capture_error",
    DINEOUT_HERO_INLINE_EVENT_CAPTURE_ERROR = "dineout_hero_inline_event_capture_error",
    ERROR_IN_JUSPAY_TOKEN = "error_in_juspay_token",

    // swiggy upi
    SWIGGY_UPI_ACCOUNTS_MISMATCH = "swiggy_upi_accounts_mismatch",
    SWIGGY_UPI_PAYMENT_FAILURE = "swiggy_upi_payment_failure",
    SWIGGY_UPI_SDK_ERROR = "swiggy_upi_sdk_error",

    // group ordering
    GROUP_CART_WEB_VIEW = "group_cart_web_view",
    GROUP_CART_TO_CHECKOUT_TRANSITION = "group_cart_to_checkout_transition",
    GROUP_CART_LOCK_API_FAILURE = "group_cart_lock_api_failure",
    GROUP_CART_GENERIC_ERROR_IMPRESSION = "group_cart_generic_error_impression",

    // EMI
    EMI_PAYMENT_GROUP_ERROR = "emi_payment_group_error",

    // Delivery Renderer
    EMPTY_DELIVERY_RENDERER_ERROR = "empty_delivery_renderer_error",

    // upi intent - mweb
    MWEB_UPI_INTENT_REDIRECT_FAILURE = "mweb_upi_intent_redirect_failure",

    // incorrect card bin
    INCORRECT_CARD_BIN = "checkout_web_incorrect_card_bin",

    // super ui
    ONE_GRATIFICATION_POPUP_EVENTS = "one_gratification_popup_events",

    ONE_GRATIFICATION_HALF_CARD_EVENTS = "one_gratification_half_card_events",

    FETCH_APP_STORAGE_DATA = "fetch_app_storage_data",

    // global JS bridge tracking
    GLOBAL_JS_BRIDGE_INCORRECT_TRIGGER = "checkout_global_js_bridge_invalid_trigger",

    // ipl timer triggers
    IPL_SWIGGY_SIXES_DEBUG = "ipl_swiggy_sixes_debug",

    EMPTY_REMOVE_PLAN_MESSAGE = "empty_remove_plan_message",

    //cart address nudge
    CART_ADDRESS_NUDGE_CONFIG = "cart_address_nudge_config",

    // turbo payment widget amount mismatch
    TURBO_CART_AMOUNT_MISMATCH = "turbo_cart_amount_mismatch",
    TURBO_CART_AMOUNT_MISMATCH_V2 = "turbo_cart_amount_mismatch_v2",
    TURBO_CART_AMOUNT_MISMATCH_V3 = "turbo_cart_amount_mismatch_v3",
    TURBO_PAY_WIDGET_HIDDEN_DUE_TO_ERROR = "turbo_pay_widget_hidden_due_to_error",
    TURBO_PAY_WIDGET_SHOWN = "turbo_pay_widget_shown",
    // gifting cart
    GIFTING_CART_ERROR_SCREEN = "gifting_cart_error_screen",

    // DO Webview refresh
    DO_WV_REFRESH_CONFIG_ERROR = "do_wv_refresh_config_error",

    // to do remove after Mweb apply coupon debug is done
    CUSTOM_TRACKING_EVENT = "custom_tracking_event",

    // EMI
    EMI_DASH_ERROR = "emi_dash_error",
    // bill image required
    OPEN_BILL_IMAGE_WEBVIEW_ERROR = "open_bill_image_webview_error",
    CLEAR_BILL_IMAGES_ERROR = "clear_bill_images_error",
    REQUEST_FOR_BILL_IMAGE_ERROR = "request_for_bill_image_error",

    // native custom back handling
    // TODO: will remove after this is stable
    // ETA: Nov Mid release
    // Owned by: Shivam Bhasin
    NATIVE_CUSTOM_BACK_HANDLING = "native_custom_back_handling",

    // Turbo pay button click tracking for saved card OTP debugging
    TURBO_PAY_BUTTON_CLICK_DEBUG = "turbo_pay_button_click_debug",

    //Empty page
    EMPTY_PAGE_RENDERED = "EMPTY_PAGE_RENDERED",

    // cart optimisation
    DINEOUT_WEBCART_RESPONSE_CACHING = "dineout_webcart_response_caching",
    // Amazon Pay
    AMAZON_PAY_SDK_UPGRADE_NR_EVENTS = "amazon_pay_sdk_upgrade_nr_events",

    // email auto suggest
    EMAIL_AUTO_SUGGEST_ERROR = "email_auto_suggest_error",

    // expense code session storage
    EXPENSE_CODE_SESSION_STORAGE_ERROR = "expense_code_session_storage_error",
    // cart prefetch via direct bridge
    PREFETCH_CART = "prefetch_cart",

    // Toing Price Comparison Image Upload Error
    TOING_PRICE_COMPARISON_IMAGE_UPLOAD_ERROR = "toing_price_comparison_image_upload_error",
    // performance instrumentation
    CHECKOUT_WEB_PERF_MARKS = "checkout_web_perf_marks",

    // popstate debug on redirect page (Android PWA CCT interception)
    PWA_REDIRECT_POPSTATE_DEBUG = "pwa_redirect_popstate_debug",

    PL_BILL_DETAILS_EVENTS = "pl_bill_details_events",
    // split bill
    SPLIT_BILL_CONTACT_PICKER_ERROR = "split_bill_contact_picker_error",

    // swiggy one journey observability
    DEBUG_SWIGGY_ONE_JOURNEY = "debug_swiggy_one_journey",

    // table reservation celebration halfcard
    TABLE_RESERVATION_CELEBRATION_HALFCARD_IMPRESSION = "table_reservation_celebration_halfcard_impression",
    TABLE_RESERVATION_CELEBRATION_SOUND_NOT_READY = "table_reservation_celebration_sound_not_ready",
    TABLE_RESERVATION_CELEBRATION_SOUND_PLAYED = "table_reservation_celebration_sound_played",

    // todo: to be removed post imtr scale up
    IMTR_DEBUG_LOGS = "imtr_debug_logs",
}
